import React, { useState } from 'react';
import ListarProgramas from './ListarProgramas';
import RegistrarProgramas from './RegistrarProgramas';

const Programas = () => {
   const [refresh, setRefresh] = useState(false); 

   const actualizarProgramas = () => {
    setRefresh(prev => !prev);  // Cambia el estado para forzar la actualización
  };

  return (
    <div>
      <RegistrarProgramas actualizarProgramas={actualizarProgramas} />
      <ListarProgramas refresh={refresh} />
    </div>
  )
}

export default Programas
